// Load optional attribution logic after the application starts. This small
// facade keeps it out of every public route's initial static bundle.
import { MEASUREMENT_NOTICE_VERSION, type MeasurementBootstrap } from './measurementContract';
// Synchronous denial stays available even if optional privacy UI cannot load.
export const GOOGLE_DENIAL_SIGNAL = 'lw_google_measurement_denied_v1';
export const googleMeasurementState = { denied: false, generation: 0 };
export function markGoogleMeasurementDenied(): void {
  googleMeasurementState.generation++;
  googleMeasurementState.denied = true;
  try { localStorage.setItem(GOOGLE_DENIAL_SIGNAL, crypto.randomUUID()); } catch { /* server receipt remains authoritative */ }
}

const NOTICE_RECEIPT = 'lw_measurement_notice_v1';
let runtime: Promise<typeof import('./measurementRuntime')> | undefined;
let loaded: typeof import('./measurementRuntime') | undefined;
const load = () => runtime ??= import('./measurementRuntime').then(m => { loaded = m; return m; });
export const getServerDenied = () => loaded?.getServerDenied() ?? null;
export const getServerGpc = () => loaded?.getServerGpc() ?? null;
export const bootstrapMeasurement = (): Promise<MeasurementBootstrap | null> => load().then(m => m.bootstrapMeasurement()).catch(() => null);
export const initializePrivacyNotice = (active: () => boolean, context: (value: MeasurementBootstrap | null) => void, show: () => void): Promise<void> => load().then(m => m.initializePrivacyNotice(active, context, show));
export const recordVisibleNotice = (active: () => boolean): Promise<void> => load().then(m => m.recordVisibleNotice(active)).catch(() => undefined);
export const presentMeasurementNotice = (denied: boolean, gpc: boolean): Promise<void> => load().then(m => m.presentMeasurementNotice(denied, gpc)).catch(() => undefined);
export const revokeMeasurement = (): Promise<boolean> => load().then(m => m.revokeMeasurement(true)).catch(() => false);
export const waitForMeasurementCapture = (): Promise<void> => load().then(m => m.waitForMeasurementCapture()).catch(() => undefined);
export function needsMeasurementNotice(): boolean {
  try { return window.localStorage.getItem(NOTICE_RECEIPT) !== MEASUREMENT_NOTICE_VERSION; } catch { return true; }
}
/** OK acknowledges disclosure only; it never grants consent. */
export function dismissMeasurementNotice(): void {
  try { window.localStorage.setItem(NOTICE_RECEIPT, MEASUREMENT_NOTICE_VERSION); } catch { /* show again */ }
}

export const allowMeasurement = (): Promise<boolean> => load().then(m => m.allowMeasurement()).catch(() => false);
export const restoreAnalytics = (current: () => boolean, receipt: string | null): Promise<boolean> => load().then(m => m.restoreAnalytics(current, receipt)).catch(() => false);

export const captureAfterAllow = (): Promise<void> => load().then(m => m.captureAfterAllow()).catch(() => undefined);
export const revokeGoogleMeasurement = (): Promise<boolean> => {
  markGoogleMeasurementDenied();
  return load().then(m => m.revokeGoogleMeasurement(true)).catch(() => false);
};
